<template>
    <div id="app">
        <header>
            <div class="logo">
                <img src="@/assets/logo.png" />
            </div>
            <nav @click="handleNav">
                <div class="nav-menu">
                    <b>{{ columns.find((item) => item.id == columnId).name }}</b>
                    <i class="icon-menu"></i>
                </div>
                <ul :class="showSubNav ? 'opened' : ''">
                    <li v-for="item in columns" @click="handelMenu('/')" :key="item.id" :class="columnId == item.id ? 'active' : ''">
                        <router-link :to="{ name: 'column', params: { column: item.id } }" :replace="true"
                            ><span>{{ item.name }}</span></router-link
                        >
                    </li>
                </ul>
            </nav>
        </header>
        <router-view />
        <footer>
            <img src="@/assets/footer-logo.png" />
            <p>email：<a href="mailto:frank@inlarks.com">frank@inlarks.com</a></p>
            <p>© 2019 INLARKS <a target="_blank" href="https://beian.miit.gov.cn">京ICP备20020205号-1</a></p>
        </footer>
        <vue-ui-loading v-if="showLoading" :msg="msg"></vue-ui-loading>
    </div>
</template>
<script>
import Vue from "vue";
import columns from "@/column.config.js";

export default {
    data() {
        return {
            columnId: columns[0].id,
            columns: columns,
            showLoading: false,
            dialog: {},
            msg: "加载中...",
            showSubNav: false,
        };
    },
    beforeCreate() {
        Vue.prototype.$showLoading = (_msg) => {
            if (_msg) this.msg = _msg;
            this.showLoading = true;
        };
        Vue.prototype.$hideLoading = () => {
            this.showLoading = false;
        };
        Vue.prototype.$alert = (arg) => {
            this.dialog = arg;
        };
        this.$http.defaults({
            $400: (err) => {
                this.$alert({
                    title: "提示",
                    content: err.response.data ? err.response.data : err.response.statusText,
                });
            },
            $finally: () => {
                this.$hideLoading();
            },
        });
    },
    mounted() {
        if (this.$route.params.column) this.columnId = this.$route.params.column;
    },
    watch: {
        $route(to) {
            this.columnId = to.params.column;
        },
    },
    methods: {
        handelMenu(idx) {
            this.navIdx = idx;
        },
        handleNav() {
            this.showSubNav = !this.showSubNav;
        },
    },
};
</script>

<style>
* {
    padding: 0;
    margin: 0;
    color: #ddd;
}

#app {
    font-family: Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

body {
    background: #313b45;
    font-size: 14px;
}

li {
    list-style: none;
}

a {
    text-decoration: none;
}

header {
    text-align: center;
}

.logo {
    margin: 0 auto;
    width: auto;
}

.vel-modal {
    background: rgba(0, 0, 0, 0.95) !important;
}

@font-face {
    font-family: "iconfont";
    src: url("data:font/woff2;charset=utf-8;base64,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") format("woff2"), url("data:font/woff;charset=utf-8;base64,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") format("woff");
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}

[class^="icon-"],
[class*=" icon-"] {
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.icon-loading:before {
    content: "\ea27";
}

.icon-loading {
    animation: loading 3s linear infinite;
}

@keyframes loading {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.icon-more-down:before {
    content: "\e680";
}

.icon-copy:before {
    content: "\e61b";
}

.icon-share:before {
    content: "\e605";
}

.icon-close:before {
    content: "\e60b";
}

.icon-play:before {
    content: "\e66e";
}

.icon-menu:before {
    content: "\e61e";
}

img {
    vertical-align: middle;
    max-width: 100%;
}

@media screen and (max-width: 600px) {
    header {
        margin: 15px 0;
    }

    .logo img {
        width: 80px;
    }

    nav {
        margin: 20px 15px;
        border: 1px #4f5861 solid;
    }

    .nav-menu {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .nav-menu b {
        margin: 0 10px;
    }

    .nav-menu i {
        margin: 0 10px;
        font-size: 24px;
    }

    nav ul {
        width: 100%;
        height: 0;
        overflow: hidden;
        transform: height 1s;
    }

    nav ul li {
        display: flex;
        height: 40px;
        align-items: center;
        justify-content: center;
        background: #3a434d;
        position: relative;
        width: 100%;
    }

    nav ul li::after {
        content: "";
        transform: scaleY(0.3);
        position: absolute;
        border-top: 1px solid #4f5861;
        left: 0;
        top: 0;
        right: 0;
    }

    nav ul li a {
        display: inline-block;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .opened {
        height: auto;
    }

    footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 50px 0;
        position: relative;
    }

    footer img {
        width: 100px;
    }

    footer p {
        text-align: center;
        font-size: 12px;
        margin: 10px 0 0 0;
    }

    footer p a {
        text-decoration: underline;
    }

    footer::before {
        content: "";
        transform: scaleY(0.3);
        position: absolute;
        border-top: 1px solid #4f5861;
        left: 0;
        top: 0;
        right: 0;
    }
}

@media screen and (min-width: 601px) {
    header {
        margin: 30px 0;
        width: 100%;
    }

    .logo img {
        width: 200px;
    }

    .nav-menu {
        display: none;
    }

    nav ul {
        display: flex;
        margin: 50px 0;
        justify-content: center;
    }

    nav ul li {
        width: 100px;
        height: 40px;
        margin: 0 20px;
    }

    nav ul li a {
        font-weight: bold;
        display: inline-flex;
        height: 100%;
        width: 100%;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    nav ul li a span {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    nav ul li a::after {
        content: "";
        display: block;
        width: 100%;
        height: 0;
        z-index: -1;
        background: #4f5861;
        -webkit-transition: height 0.2s;
        -moz-transition: height 0.2s;
        -ms-transition: height 0.2s;
        -o-transition: height 0.2s;
        transition: height 0.2s;
    }

    nav ul li a:hover,
    nav ul li a:hover::after {
        height: 40px;
        top: 0;
    }

    .active a {
        background: #4f5861;
    }

    .video-js .vjs-big-play-button {
        left: 50% !important;
        top: 50% !important;
        background: none !important;
        border: none !important;
        margin: -35px 0 0 -35px;
    }

    .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
        font-family: "iconfont" !important;
        font-size: 70px;
        line-height: 70px !important;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        content: "\e66e" !important;
        width: auto !important;
        height: auto !important;
        color: #fff !important;
    }

    footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 50px 0;
        position: relative;
        margin-top: 100px;
    }

    footer img {
        width: 100px;
    }

    footer p {
        text-align: center;
        font-size: 12px;
        margin: 10px 0 0 0;
    }

    footer p a {
        text-decoration: underline;
    }

    footer::before {
        content: "";
        transform: scaleY(0.5);
        position: absolute;
        border-top: 1px solid #4f5861;
        left: 0;
        top: 0;
        right: 0;
    }
}

.fade-enter-active {
    animation: fade-in 0.3s ease;
}

.fade-leave-active {
    animation: fade-in 0.3s ease reverse;
}

.vue-waterfall-easy img {
    cursor: pointer;
}

.vue-waterfall-easy .over {
    display: none;
}

@keyframes fade-in {
    0% {
        transform: scale(0);
    }

    100% {
        transform: scale(1);
    }
}

@import url("~@/content.css");
</style>
